import user from "./user";
import order from "./order";
import activity from "./activity";
import admin from "./admin";
import mendian from "./mendian";

export default [...user, ...order, ...activity, ...admin, ...mendian];
